import React, { useState, useEffect } from "react";
import { Icon, Button, TextArea } from "semantic-ui-react";
import DijonCard from "./DijonCard";
import axiosInstance from "../../lib/auth/axiosApi";

const NOTE_COLORS = ['yellow', 'pink', 'blue', 'green', 'purple'];
const COLOR_MAP = {
  yellow: { bg: '#fff9c4', border: '#f9e547' },
  pink: { bg: '#fce4ec', border: '#f48fb1' },
  blue: { bg: '#e3f2fd', border: '#64b5f6' },
  green: { bg: '#e8f5e9', border: '#81c784' },
  purple: { bg: '#f3e5f5', border: '#ce93d8' },
};

function DijonRandom(props) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNotes();
  }, []);

  const fetchNotes = async () => {
    try {
      const res = await axiosInstance.get('notes/');
      setNotes(res.data.results || res.data);
    } catch (e) {}
    setLoading(false);
  };

  const addNote = async () => {
    try {
      const color = NOTE_COLORS[notes.length % NOTE_COLORS.length];
      const res = await axiosInstance.post('notes/', { content: '', color });
      setNotes(prev => [res.data, ...prev]);
    } catch (e) {}
  };

  const updateNote = async (id, content) => {
    setNotes(prev => prev.map(n => n.id === id ? { ...n, content } : n));
    try {
      await axiosInstance.patch(`notes/${id}/`, { content });
    } catch (e) {}
  };

  const deleteNote = async (id) => {
    setNotes(prev => prev.filter(n => n.id !== id));
    try {
      await axiosInstance.delete(`notes/${id}/`);
    } catch (e) {}
  };

  return (
    <div id="random">
      <DijonCard
        width={'500px'}
        height={'70vh'}
        activeCards={props.activeCards}
        setActiveCards={props.setActiveCards}
        name={'random'}
        content={
          <div style={{ height: '100%', overflow: 'auto', padding: '15px', background: '#2d2d2d' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
              <h3 style={{ color: '#d8ac49', margin: 0 }}>Quick Notes</h3>
              <Button size="tiny" color="yellow" onClick={addNote}>
                <Icon name="plus" /> New Note
              </Button>
            </div>

            {notes.length === 0 && !loading && (
              <div style={{ textAlign: 'center', padding: '30px', color: '#888' }}>
                <Icon name="sticky note outline" size="huge" />
                <p style={{ marginTop: '10px' }}>No notes yet. Click "New Note" to start.</p>
              </div>
            )}

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {notes.map(note => {
                const colors = COLOR_MAP[note.color] || COLOR_MAP.yellow;
                return (
                  <div
                    key={note.id}
                    style={{
                      width: 'calc(50% - 5px)',
                      minHeight: '120px',
                      background: colors.bg,
                      border: `2px solid ${colors.border}`,
                      borderRadius: '4px',
                      padding: '8px',
                      position: 'relative',
                    }}
                  >
                    <Icon
                      name="trash"
                      size="small"
                      style={{
                        position: 'absolute', top: '5px', right: '5px',
                        cursor: 'pointer', color: '#999', opacity: 0.5,
                      }}
                      onClick={() => deleteNote(note.id)}
                    />
                    <TextArea
                      value={note.content}
                      onChange={(e) => updateNote(note.id, e.target.value)}
                      placeholder="Write something..."
                      style={{
                        width: '100%',
                        minHeight: '90px',
                        border: 'none',
                        background: 'transparent',
                        resize: 'vertical',
                        fontFamily: "'Segoe UI', sans-serif",
                        fontSize: '13px',
                        outline: 'none',
                        color: '#333',
                      }}
                    />
                    <div style={{ fontSize: '0.7em', color: '#999', marginTop: '4px' }}>
                      {new Date(note.updated_at).toLocaleDateString()}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        }
      />
    </div>
  );
}

export default DijonRandom;
